module.exports = __webpack_public_path__ + "img/bill-right-bottom.18dc8494.png";